import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, X } from 'lucide-react';

const SortableStep = ({ step, stepIndex, partIndex, children, onRemoveStep }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: `step-${partIndex}-${stepIndex}` });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <div ref={setNodeRef} style={style} className="step-box">
            <div className="step-header">
                <div className="drag-handle" {...attributes} {...listeners}>
                    <GripVertical size={16} />
                </div>

                {onRemoveStep && (
                    <button
                        type="button"
                        onClick={() => onRemoveStep(partIndex, stepIndex)}
                        className="remove-step-btn"
                    >
                        <X size={16} />
                    </button>
                )}
            </div>
            {children}
        </div>
    );
};

export default SortableStep;
